import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDn1vpDO4cnImVPqCrXtcEuITmW2QhC6t0",
  authDomain: "southie-totus-tuus.firebaseapp.com",
  projectId: "southie-totus-tuus",
  storageBucket: "southie-totus-tuus.firebasestorage.app",
  messagingSenderId: "662432950217",
  appId: "1:662432950217:web:42700f3c48dd26dd812a18",
  measurementId: "G-875BY4KV1W"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

export const db = getFirestore(app);
export const storage = getStorage(app);
